var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccountSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "rfs8bbcyaa",
    d: "M21 0L0 9.333v14c0 12.95 8.96 25.06 21 28 12.04-2.94 21-15.05 21-28v-14L21 0m0 9.333c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7m11.97 28c-2.823 4.317-7.047 7.56-11.97 9.147-4.923-1.587-9.147-4.83-11.97-9.147C8.237 36.167 7.56 35 7 33.763c0-3.85 6.323-7 14-7s14 3.08 14 7c-.56 1.237-1.237 2.404-2.03 3.57z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0z",
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000) translate(7.000000, 2.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bht44p76lb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rfs8bbcyaa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#rfs8bbcyaa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6600EA",
    mask: "url(#bht44p76lb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 56L56 56 56 0 0 0z",
    transform: "translate(-7.000000, -2.333333)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountSecurity);
export default __webpack_public_path__ + "static/media/icon-account-security.25a469b8d46240ff03427fcfee6e7cfb.svg";
export { ForwardRef as ReactComponent };